import React from "react";
import { Skel } from "./Skeleton";

export default function RelatorioSkeleton() {
  return (
    <div className="rel-skel">
      {/* Cabeçalho do relatório */}
      <div className="rel-skel__head">
        <Skel className="skel-line lg rel-skel__t1" />
        <Skel className="skel-line rel-skel__t2" />
      </div>

      {/* Cards (KPIs) */}
      <div className="rel-skel__kpis">
        {Array.from({ length: 4 }).map((_, i) => (
          <div key={i} className="rel-skel__card">
            <Skel className="skel-line sm" style={{ width: 90, marginBottom: 10 }} />
            <Skel className="skel-line lg" style={{ width: 120, marginBottom: 8 }} />
            <Skel className="skel-line sm" style={{ width: 160 }} />
          </div>
        ))}
      </div>

      {/* “Gráfico” */}
      <div className="rel-skel__box">
        <Skel className="skel-line sm" style={{ width: 140, marginBottom: 12 }} />
        <Skel className="rel-skel__chart" />
      </div>

      {/* “Tabela” */}
      <div className="rel-skel__box">
        <Skel className="skel-line sm" style={{ width: 180, marginBottom: 12 }} />
        <div className="rel-skel__table">
          {Array.from({ length: 6 }).map((_, i) => (
            <div key={i} className="rel-skel__row">
              <Skel className="skel-line" />
              <Skel className="skel-line" />
              <Skel className="skel-line" />
              <Skel className="skel-line" />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}